import { useMutation } from "@shared/lib/hooks";
import { IScriptCompliance } from "@shared/lib/types/scripting";
import { BriefService } from "../../services/brief.service";

export default function useGenerateScriptCompliance() {
  const {
    mutate: generateScriptCompliance,
    isLoading: isGeneratingScriptCompliance,
    isSuccess: isGeneratingScriptComplianceSuccess,
    error: generatingScriptComplianceError,
    variables: generatedScriptComplianceParams,
  } = useMutation({
    mutationFn: (data: IScriptCompliance) =>
      BriefService.generateScriptingCompliance(data),
    options: {
      skipInvalidation: true,
    },
  });

  return {
    generateScriptCompliance,
    isGeneratingScriptCompliance,
    isGeneratingScriptComplianceSuccess,
    generatingScriptComplianceError,
    generatedScriptComplianceParams,
  };
}
